import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=61e7f630&scoped=true&"
import script from "./Resources.vue?vue&type=script&setup=true&lang=js&"
export * from "./Resources.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7f630",
  null
  
)

export default component.exports